import { bindable, computedFrom, autoinject } from 'aurelia-framework';
import { Account } from '../../../../models/customer';
import { Router } from 'aurelia-router';
import { SelectedAccountsSettings } from '../selected-accounts-settings';

@autoinject
export class CardAutopaySetup {
	selectedAccounts: Array<Account> = [];
	selectedAccountsSettings: SelectedAccountsSettings;

	constructor(private router: Router) {

	}

	activate(model) {
		if (!!model) {
			this.selectedAccounts = model.selectedAccounts;
			this.selectedAccountsSettings = model.selectedAccountsSettings;
		}
	}

	goToSetup() {
		// assume only one account can be selected
		this.router.navigateToRoute(`autopay/setup-autopay`, { id: this.selectedAccounts[0].id });
	}
}
